export interface Currency {
  country: string;
  currency: string;
  symbol: string;
}

export const countryRegions = [
  {
    region: 'North America',
    countries: [
      {
        country: 'Canada',
        marketplaceId: 'A2EUQ1WTGCTBG2',
        countryCode: 'CA',
        flag: '🇨🇦',
        timezoneOffset: -300, // UTC-5 (Eastern Standard Time, varies by region)
        location: 'America/Toronto (EST)',
        currencySymbol : 'CA$',
        prefferedLanguage : 'en-CA',
        currencyCode : 'CAD'

      },
      {
        country: 'United States of America',
        marketplaceId: 'ATVPDKIKX0DER',
        countryCode: 'US',
        flag: '🇺🇸',
        timezoneOffset: -300, // UTC-5 (Eastern Standard Time, varies by region)
        location: 'America/New_York (EST)',
        currencySymbol : '$',
        prefferedLanguage : 'en-US',
        currencyCode : 'USD'
      },
      {
        country: 'Mexico',
        marketplaceId: 'A1AM78C64UM0Y8',
        countryCode: 'MX',
        flag: '🇲🇽',
        timezoneOffset: -360, // UTC-6
        location: 'America/Mexico_City (CST)',
        currencySymbol : 'MX$',
        prefferedLanguage : 'es-MX',
        currencyCode : 'MXN'
      },
      {
        country: 'Brazil',
        marketplaceId: 'A2Q3Y263D00KWC',
        countryCode: 'BR',
        flag: '🇧🇷',
        timezoneOffset: -180, // UTC-3
        location: 'America/Sao_Paulo (BRT)',
        currencySymbol : 'R$',
        prefferedLanguage : 'pt-BR',
        currencyCode : 'BRL'
      },
    ],
  },
  {
    region: 'Europe',
    countries: [
      {
        country: 'Ireland',
        marketplaceId: 'A28R8C7NBKEWEA',
        countryCode: 'IE',
        flag: '🇮🇪',
        timezoneOffset: 0, // UTC+0
        location: 'Europe/Dublin (GMT)',
        currencySymbol : '€',
        prefferedLanguage : 'en-IE',
        currencyCode : 'EUR'
      },
      {
        country: 'Spain',
        marketplaceId: 'A1RKKUPIHCS9HS',
        countryCode: 'ES',
        flag: '🇪🇸',
        timezoneOffset: 60, // UTC+1
        location: 'Europe/Madrid (CET)',
        currencySymbol : '€',
        prefferedLanguage : 'es-ES',
        currencyCode : 'EUR'
      },
      {
        country: 'United Kingdom',
        marketplaceId: 'A1F83G8C2ARO7P',
        countryCode: 'UK',
        flag: '🇬🇧',
        timezoneOffset: 0, // UTC+0
        location: 'Europe/London (GMT)',
        currencySymbol : '£',
        prefferedLanguage : 'en-GB',
        currencyCode : 'GBP'
      },
      {
        country: 'France',
        marketplaceId: 'A13V1IB3VIYZZH',
        countryCode: 'FR',
        flag: '🇫🇷',
        timezoneOffset: 60, // UTC+1
        location: 'Europe/Paris (CET)',
        currencySymbol : '€',
        prefferedLanguage : 'fr-FR',
        currencyCode : 'EUR'
      },
      {
        country: 'Belgium',
        marketplaceId: 'AMEN7PMS3EDWL',
        countryCode: 'BE',
        flag: '🇧🇪',
        timezoneOffset: 60, // UTC+1
        location: 'Europe/Brussels (CET)',
        currencySymbol : '€',
        prefferedLanguage : 'nl-BE',
        currencyCode : 'EUR'
      },
      {
        country: 'Netherlands',
        marketplaceId: 'A1805IZSGTT6HS',
        countryCode: 'NL',
        flag: '🇳🇱',
        timezoneOffset: 60, // UTC+1
        location: 'Europe/Amsterdam (CET)',
        currencySymbol : '€',
        prefferedLanguage : 'nl-NL',
        currencyCode : 'EUR'
      },
      {
        country: 'Germany',
        marketplaceId: 'A1PA6795UKMFR9',
        countryCode: 'DE',
        flag: '🇩🇪',
        timezoneOffset: 60, // UTC+1
        location: 'Europe/Berlin (CET)',
        currencySymbol : '€',
        prefferedLanguage : 'de-DE',
        currencyCode : 'EUR'
      },
      {
        country: 'Italy',
        marketplaceId: 'APJ6JRA9NG5V4',
        countryCode: 'IT',
        flag: '🇮🇹',
        timezoneOffset: 60, // UTC+1
        location: 'Europe/Rome (CET)',
        currencySymbol : '€',
        prefferedLanguage : 'it-IT',
        currencyCode : 'EUR'
      },
      {
        country: 'Sweden',
        marketplaceId: 'A2NODRKZP88ZB9',
        countryCode: 'SE',
        flag: '🇸🇪',
        timezoneOffset: 60, // UTC+1,
        location: 'Europe/Stockholm (CET)',
        currencySymbol : 'kr',
        prefferedLanguage : 'sv-SE',
        currencyCode : 'SEK'
      },
      {
        country: 'Poland',
        marketplaceId: 'A1C3SOZRARQ6R3',
        countryCode: 'PL',
        flag: '🇵🇱',
        timezoneOffset: 60, // UTC+1
        location: 'Europe/Warsaw (CET)',
        currencySymbol : 'zł',
        prefferedLanguage : 'pl-PL',
        currencyCode : 'PLN'
      },
      {
        country: 'Turkey',
        marketplaceId: 'A33AVAJ2PDY3EV',
        countryCode: 'TR',
        flag: '🇹🇷',
        timezoneOffset: 180, // UTC+3
        location: 'Europe/Istanbul (TRT)',
        currencySymbol : '₺',
        prefferedLanguage : 'tr-TR',
        currencyCode : 'TRY'
      },
    ],
  },
  {
    region: 'Africa',
    countries: [
      {
        country: 'South Africa',
        marketplaceId: 'AE08WJ6YKNBMC',
        countryCode: 'ZA',
        flag: '🇿🇦',
        timezoneOffset: 120, // UTC+2
        location: 'Africa/Johannesburg (SAST)',
        currencySymbol : 'R',
        prefferedLanguage : 'en-ZA',
        currencyCode : 'ZAR'
      },
      {
        country: 'Egypt',
        marketplaceId: 'ARBP9OOSHTCHU',
        countryCode: 'EG',
        flag: '🇪🇬',
        timezoneOffset: 120, // UTC+2
        location: 'Africa/Cairo (EET)',
        currencySymbol : 'E£',
        prefferedLanguage : 'ar-EG',
        currencyCode : 'EGP'
      },
    ],
  },
  {
    region: 'Middle East',
    countries: [
      {
        country: 'Saudi Arabia',
        marketplaceId: 'A17E79C6D8DWNP',
        countryCode: 'SA',
        flag: '🇸🇦',
        timezoneOffset: 180, // UTC+3
        location: 'Asia/Riyadh (AST)',
        currencySymbol : '﷼',
        prefferedLanguage : 'ar-SA',
        currencyCode : 'SAR'
      },
      {
        country: 'United Arab Emirates',
        marketplaceId: 'A2VIGQ35RCS4UG',
        countryCode: 'AE',
        flag: '🇦🇪',
        timezoneOffset: 240, // UTC+4
        location: 'Asia/Dubai (GST)',
        currencySymbol : 'د.إ',
        prefferedLanguage : 'ar-AE',
        currencyCode : 'AED'
      },
    ],
  },
  {
    region: 'Far East',
    countries: [
      {
        country: 'India',
        marketplaceId: 'A21TJRUUN4KGV',
        countryCode: 'IN',
        flag: '🇮🇳',
        timezoneOffset: 330, // UTC+5:30
        location: 'Asia/Kolkata (IST)',
        currencySymbol : '₹',
        prefferedLanguage : 'en-IN',
        currencyCode : 'INR'
      },
      {
        country: 'Singapore',
        marketplaceId: 'A19VAU5U5O7RUS',
        countryCode: 'SG',
        flag: '🇸🇬',
        timezoneOffset: 480, // UTC+8
        location: 'Asia/Singapore (SGT)',
        currencySymbol : 'S$',
        prefferedLanguage : 'en-SG',
        currencyCode : 'SGD'
      },
      {
        country: 'Australia',
        marketplaceId: 'A39IBJ37TRP1C6',
        countryCode: 'AU',
        flag: '🇦🇺',
        timezoneOffset: 600, // UTC+10 (Sydney/Melbourne)
        location: 'Australia/Sydney (AEST)',
        currencySymbol : 'A$',
        prefferedLanguage : 'en-AU',
        currencyCode : 'AUD'
      },
      {
        country: 'Japan',
        marketplaceId: 'A1VC38T7YXB528',
        countryCode: 'JP',
        flag: '🇯🇵',
        timezoneOffset: 540, // UTC+9
        location: 'Asia/Tokyo (JST)',
        currencySymbol : '¥',
        prefferedLanguage : 'ja-JP',
        currencyCode : 'JPY'
      },
    ],
  },
];


export const countryCurrencyMap = {
  CA: { country: 'Canada', currency: 'CAD', symbol: 'CA$' },
  US: { country: 'United States of America', currency: 'USD', symbol: '$' },
  MX: { country: 'Mexico', currency: 'MXN', symbol: 'MX$' },
  BR: { country: 'Brazil', currency: 'BRL', symbol: 'R$' },

  IE: { country: 'Ireland', currency: 'EUR', symbol: '€' },
  ES: { country: 'Spain', currency: 'EUR', symbol: '€' },
  UK: { country: 'United Kingdom', currency: 'GBP', symbol: '£' },
  FR: { country: 'France', currency: 'EUR', symbol: '€' },
  BE: { country: 'Belgium', currency: 'EUR', symbol: '€' },
  NL: { country: 'Netherlands', currency: 'EUR', symbol: '€' },
  DE: { country: 'Germany', currency: 'EUR', symbol: '€' },
  IT: { country: 'Italy', currency: 'EUR', symbol: '€' },
  SE: { country: 'Sweden', currency: 'SEK', symbol: 'kr' },
  ZA: { country: 'South Africa', currency: 'ZAR', symbol: 'R' },
  PL: { country: 'Poland', currency: 'PLN', symbol: 'zł' },
  EG: { country: 'Egypt', currency: 'EGP', symbol: 'E£' },
  TR: { country: 'Turkey', currency: 'TRY', symbol: '₺' },
  SA: { country: 'Saudi Arabia', currency: 'SAR', symbol: '﷼' },
  AE: { country: 'United Arab Emirates', currency: 'AED', symbol: 'د.إ' },
  IN: { country: 'India', currency: 'INR', symbol: '₹' },

  SG: { country: 'Singapore', currency: 'SGD', symbol: 'S$' },
  AU: { country: 'Australia', currency: 'AUD', symbol: 'A$' },
  JP: { country: 'Japan', currency: 'JPY', symbol: '¥' },
};
export const currencySymbolMap = {
  CAD: 'CA$',
  USD: '$',
  MXN: 'MX$',
  BRL: 'R$',

  EUR: '€',
  GBP: '£',
  SEK: 'kr',
  ZAR: 'R',
  PLN: 'zł',
  EGP: 'E£',
  TRY: '₺',
  SAR: '﷼',
  AED: 'د.إ',
  INR: '₹',

  SGD: 'S$',
  AUD: 'A$',
  JPY: '¥',
};

export const countryCodeAndFlag = {
  CA: '🇨🇦',
  US: '🇺🇸',
  MX: '🇲🇽',
  BR: '🇧🇷',
  IE: '🇮🇪',
  ES: '🇪🇸',
  UK: '🇬🇧',
  FR: '🇫🇷',
  BE: '🇧🇪',
  NL: '🇳🇱',
  DE: '🇩🇪',
  IT: '🇮🇹',
  SE: '🇸🇪',
  ZA: '🇿🇦',
  PL: '🇵🇱',
  EG: '🇪🇬',
  TR: '🇹🇷',
  SA: '🇸🇦',
  AE: '🇦🇪',
  IN: '🇮🇳',
  SG: '🇸🇬',
  AU: '🇦🇺',
  JP: '🇯🇵',
};

export const getRegionByCountryCode = (code: string): string | null => {
  // Amazon Ads API region (NA/EU/FE) — not UI geography.
  // India stays EU even though the country picker lists it under Far East.
  const adsApiRegionByCountry: Record<string, 'NA' | 'EU' | 'FE'> = {
    US: 'NA',
    CA: 'NA',
    MX: 'NA',
    BR: 'NA',
    UK: 'EU',
    IE: 'EU',
    FR: 'EU',
    ES: 'EU',
    DE: 'EU',
    IT: 'EU',
    SE: 'EU',
    PL: 'EU',
    BE: 'EU',
    NL: 'EU',
    EG: 'EU',
    TR: 'EU',
    SA: 'EU',
    AE: 'EU',
    ZA: 'EU',
    IN: 'EU',
    SG: 'FE',
    AU: 'FE',
    JP: 'FE',
  };
  return adsApiRegionByCountry[code] ?? null;
};


export const GetCurrencyByCountryCode = (code: string) => {
  const currency: Currency = countryCurrencyMap[code];
  return currency;
};

export const GetCurrencySymbolByCurrency = (currency: string) => {
  const currencySymbol: string = currencySymbolMap[currency];
  return currencySymbol;
};

export const GetFlagByCountryCode = (code: string)=>{
  const flag: string = countryCodeAndFlag[code];
  return flag;
}

